import React from 'react'
import ActivityIndicator from './forms/ActivityIndicator'
import PropTypes from 'prop-types'
import { IoShieldCheckmarkSharp } from '@react-icons/all-files/io5/IoShieldCheckmarkSharp'

const InsuredVehiclesButton = (props) => {
  const { onClick, color, disabled, count, loading, style } = props

  return (
    <button
      onClick={onClick}
      className={`button button--is-${color} button--is-motor-insured-vehicle-button`}
      style={{ backgroundColor: color ?? '#68C9D0', ...style }}
      disabled={disabled}
    >
      <div style={{ fontWeight: 'bold', fontSize: 25, alignSelf: 'center' }}>
        <IoShieldCheckmarkSharp/>
      </div>
      {loading ? (
        <div style={{ marginLeft: 10 }}>
          <ActivityIndicator color="#fff" />
        </div>
      ) : (
        <div>
          <p style={{ marginBottom: 0, marginLeft: 5, fontWeight: 'bold', fontSize: 15 }}>
            {count} <span className='insured-vehicle-button-text'> Insured Vehicle{count > 1 ? 's' : ''}</span>
          </p>
        </div>
      )}
    </button>
  )
}

InsuredVehiclesButton.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  loading: PropTypes.bool
}

export default InsuredVehiclesButton
